import { render, staticRenderFns } from "./ResourcesItem.vue?vue&type=template&id=7ba44724&scoped=true"
import script from "./ResourcesItem.vue?vue&type=script&lang=js"
export * from "./ResourcesItem.vue?vue&type=script&lang=js"
import style0 from "./ResourcesItem.vue?vue&type=style&index=0&id=7ba44724&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba44724",
  null
  
)

export default component.exports